/* eslint-disable import/prefer-default-export */

export const notAllowedDomains = ['logout', 'login', 'global'];
